import worksheetexample from "../assets/images/worksheetexample.png";
import strokeorder from "../assets/images/strokeorder.png";
import quiz from "../assets/images/quiz.png";
import typing from "../assets/gif/typing.gif";
import vocabulary from "../assets/images/vocabulary.png";

export default {
    typingwords:
        "我想上免费的日语课",

    header: {
        strokeOrder: "在线练习假名读写",
        game: '玩《这是哪个假名？》游戏',
        typing: "打字挑战！",
        vocabulary: "刷卡学日语！",
        worksheets: "免费下载练习字帖",
        about: "关于公司",
        contact: "咨询",
        message: "预约课程",
    },

    hero: {
        title: "跟我一起做三语小达人！",
        text: "快乐学习，朋友越来越多！",
        button: "现在开始",
    },

    cards: [
        { href: "/strokeorder", title: "在线练习假名读写", desc: "无需准备任何工具，直接练习平假名和片假名的读写！", image: strokeorder },
        { href: "/game", title: "《这是哪个假名？》", desc: "长得很像的平假名和片假名，你能分得清吗？", image: quiz },
        { href: "/vocabulary", title: "刷卡学日语！", desc: "滑动单词卡，快速积累日语词汇！", image: vocabulary },
        { href: "/typing", title: "打字挑战！", desc: "把你听到的词用罗马字打出来吧！", image: typing },
        { href: "/writing", title: "免费练习字帖", desc: "可打印，也可导入 Goodnotes，在家轻松练字！", image: worksheetexample},
    ],
    about: {
        hanapin: "《樱花老师》是由花拼讲授的日语教育内容，她梦想与来自世界各地的人成为朋友。你可以随时随地独自学习，从教材准备到课程学习，再到复习，全程自主完成。立即在 YouTube（英文版）或哔哩哔哩（中文版）开始学习吧！",
        fujiyama: "我们，Fujiyama, Inc. 是一家负责《樱花老师》的策划、动画和剪辑的日本公司。我们打造轻松独特、又能在日常生活中派上用场的有趣教育视频。",
        profile: {
            companyName:    "公司名称",
            established:    "成立时间",
            capital:        "注册资本",
            representative: "代表",
            business:       "业务内容",
            address:        "地址",
            qualifications: "资质认证",
            trademark:      "商标",
            bank:           "主要往来银行",
        }
    },
    news: [
        { date: "2026.07.08", title: "《刷卡学日语！》正式上线！", content: "滑动带图片和音频的单词卡，快速积累日语词汇！快来试试吧！", link: "/vocabulary", linkText: "马上体验" },
        { date: "2026.07.08", title: "《打字挑战！》正式上线！", content: "用罗马字练习打你听到的日语单词，提升听力和打字水平！快来试试吧！", link: "/typing", linkText: "马上体验" },
        { date: "2026.07.01", title: "现在可以在线练习假名读写了！", content: "无需准备任何工具，直接练习平假名和片假名的读写！", link: "/strokeorder", linkText: "点击开始练习" },
        { date: "2026.06.30", title: "现在可以玩《这是哪个假名？》游戏啦！", content: "长得很像的平假名和片假名，你能分得清吗？", link: "/game", linkText: "点击开始玩" },
        { date: "2026.03.01", title: "第一个平假名的教学视频发布了！", content: "请在YouTube上看最新的视频！", link: "https://www.youtube.com/channel/UCXFOpp-skK2-psYqVwYOj1g", linkText: "点击查看" },
        { date: "2026.02.22", title: "花拼官方网站正式上线！", content: "新视频即将在YouTube发布，敬请期待！", link: "", linkText: "了解更多" }
    ],
    characters: {
            hanapin: {
                name: "花拼", sub: "三语通的吃货日本女孩", desc: "去过美国和中国留学的日本女生。现在专门给对日语感兴趣的朋友们上日语课（看看我的YouTube！）。日常爱喝无糖奶茶、吃火锅，饭量大到常让旁人吃惊。"},
            emimaru: {
                name: "笑圆", sub: "酒鬼天才画师", desc: "爱喝酒、会画画、年年出国旅游的妈妈最近开始学习英文和中文。但因为学完的第二天就忘光，所以一直没有进步。她的口头禅是“可恶“和”给我点冰块”。"
            },
            sakura: {
                name: "上海樱花", sub: "懒懒的留学博主", desc: "来上海留学的日本大学生。因为她完全不懂中文，每天都会遇到不少困难。同时也是一名留学博主，但因为剪辑进度跟不上，觉得对粉丝不好意思。"
            },
    },
    sections: {
        otherLessons: "其他的课程",
        studyMaterials: "学习材料",
        news: "公告",
        characters: "角色介绍",
        watchYouTube: "在YouTube上看",
    },
    tags: {
    hiragana: "平假名",
    katakana: "片假名",

    single: "单字练习",
    all: "全字练习",

    "cheat-sheet-test": "速查表 & 小测验",
}
};